import { ReactElement } from "react";
import { IndicatorStatuses } from "../../../services/http/indicator/models/IndicatorStatuses";
import { className } from "../../../shared/helpers";

interface IndicatorGaugeProps
{
    status: number;
    score: number;
    size?: string;
    stroke?: string;
}

function getClassName(status: number): string | null
{
    switch (status)
    {
        case IndicatorStatuses.FullyFunctional:
            return "background-color-safe";
        case IndicatorStatuses.Warning:
            return "background-color-warning";
        case IndicatorStatuses.Critical:
            return "background-color-danger";
        case IndicatorStatuses.SystemFailure:
            return "background-color-failure";
    }

    return null;
}

const IndicatorGauge = (props: IndicatorGaugeProps): ReactElement => (
    <div
        {...className(
            "gauge-wrapper",
            props.stroke ? "stroke-" + props.stroke : "stroke-medium",
            props.size ? "size-" + props.size : ""
        )}
    >
        <span
            {...className("gauge-indicator", getClassName(props.status))}
            style={{ transform: "rotate(" + props.score * 180 + "deg)" }}
        />
    </div>
);

export default IndicatorGauge;
